import { palette } from 'src/styles/colors';
import styled, { css } from 'styled-components';
import { applyStylesToMobileExperience } from 'src/molecules/Shared/2024_Q1_people_magic/BaseAnimatedExperienceController/BaseAnimatedExperienceController.styles';
import { layout } from 'src/styles/layout';

export const FromIdeaToLiveCommunityContainer = styled.div`
  height: auto;
  padding: 6rem 1.5rem;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  background-color: ${palette.cream};

  @media all and (max-width: ${layout.subxlg}) {
    padding: 3rem 1.5rem;
  }
`;

export const FromIdeaToLiveCommunityContent = styled.div`
  width: 100%;
  margin: 0 auto;
  display: grid;
  max-width: 1280px;
  box-sizing: border-box;
  grid-template-columns: 1fr 1fr;

  @media (max-width: ${layout.subxlg}) {
    max-width: 640px;
    grid-template-columns: 1fr;
    row-gap: 1.5rem;
  }
`;

export const FromIdeaToLiveCommunityText = styled.div`
  display: grid;
  row-gap: 2.5rem;
  max-width: 485px;
  justify-self: start;
  align-self: center;

  .mobile-description {
    display: none;
  }

  .desktop-description {
    display: block;
  }

  ${applyStylesToMobileExperience(css`
    max-width: 640px;

    p,
    h1 {
      text-align: center;
    }

    .mobile-description {
      display: block;
    }

    .desktop-description {
      display: none;
    }
  `)}
`;
